import React, { Component } from 'react';
import { I18n } from 'react-i18next';

export default class Section2 extends Component {
    render () {
        return (
            <I18n>
                {
                    (t, { i18n }) => (
                        <div className="section" id="section2">
                            <div className="container">
                                <div className="row speed-title">
                                    <div className="col-md-10">
                                        <h2>Unprecedented speed and secure of network will make TRIAM the one of the flagship of Blockchain. </h2>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft">
                                        <div className="row">
                                            <div className="col-md-3 text-center img-speed">
                                                <img src="/images/intro-speed-1.png" alt={'speed'} />
                                            </div>
                                            <div className="col-md-9">
                                                <h5 className="speed-sub-title">Transaction Speed</h5>
                                                <p className="p-speed">Time is most important asset. We can provide comfortable transaction. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft">
                                        <div className="row">
                                            <div className="col-md-3 text-center img-speed">
                                                <img src="/images/intro-speed-2.png" alt={'speed'}/>
                                            </div>
                                            <div className="col-md-9">
                                                <h5 className="speed-sub-title">Security</h5>
                                                <p className="p-speed">TRIAM is placing emphasis on the security.
                                                <br/>On the other hand, no more than three seconds to verify one transaction.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft">
                                        <div className="row">
                                            <div className="col-md-3 text-center img-speed">
                                                <img src="/images/intro-speed-3.png" alt={'speed'}/>
                                            </div>
                                            <div className="col-md-9">
                                                <h5 className="speed-sub-title">Low Transaction Fee</h5>
                                                <p className="p-speed">Each transaction cost is lower than in any regular Blockchain system.
                                                <br />Small savings will become big asset.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 col-sm-3 col-md-3 s2-left wow slideInLeft">
                                        <div className="row">
                                            <div className="col-md-3 text-center img-speed">
                                                <img src="/images/intro-speed-4.png" alt={'speed'}/>
                                            </div>
                                            <div className="col-md-9">
                                                <h5 className="speed-sub-title">Multiple Functions for Wallet</h5>
                                                <p className="p-speed">Multisign wallet, Shared wallet, Issue your Tokens, Auto Transfer, Wallet App, and more!</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    )
                }
            </I18n>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/section2.jsx